import { ServiceCode } from '../models/service.code.model';

export const serviceTypeMapping: { [key: string]: string } = {
  [ServiceCode.TrashPickUpTownServiceDetailDto]: 'Trash',
  [ServiceCode.TrashPickUpAndRecyclingTownServiceDetailDto]: 'Trash & Recycling',
  [ServiceCode.FoodWasteTownServiceDetailDto]: 'Food Waste',
  [ServiceCode.BulkPickupTownServiceDetailDto]: 'Bulk Waste',
  [ServiceCode.RecyclingTownServiceDetailDto]: 'Recycling',
  [ServiceCode.CommercialTrash]: 'Trash',
  [ServiceCode.CommercialRecycling]: 'Recycling',
  [ServiceCode.CommercialTrashAndRecycling]: 'Trash & Recycling',
  [ServiceCode.CommercialFoodWaste]: 'Food Waste',
  [ServiceCode.CommercialBulk]: 'Bulk Waste',
  [ServiceCode.RollOff]: 'Dumpster Rental',
};
